import React from "react";
import { Location } from "@navigation/Location";
import { AccommodationRequestPage } from "../AccommodationRequest/AccommodationRequestPage";
import { AccommodationRequestProps } from "../AccommodationRequest/AccommodationRequestProps";

interface Params {
  bookingId?: string;
  formProps: AccommodationRequestProps;
}

export class AccommodationRequestCreateLocation extends Location<Params> {
  render() {
    return (
      <AccommodationRequestPage
        formProps={{
          ...this.params.formProps,
          isNew: true,
          lookupWorkplaceAddress: true
        }}
      />
    );
  }

  equals(location: Location<Params>): boolean {
    return this.params.bookingId === location.params.bookingId;
  }

  toURI(): string {
    if (this.params.bookingId) {
      return `/bookings/${this.params.bookingId}/accommodation-request`;
    } else {
      return `/accommodation-request`;
    }
  }
}
